import { Flex, Box } from '@cad-arc';
import { EventSearchOptions } from '@mark43/cad-api';
import { UseFormReturn } from 'react-hook-form';
import { FormSelect } from '../forms/integrated-form-controls/form-select';
import { FormUserMultiSelect } from '../forms/integrated-form-controls/form-user-multi-select';
import { FormSection } from '../search-windows/form-section';
import { EventSearchFormType } from './types';
import { INPUT_WIDTH_SM } from '../search-windows/constants';

export function EventSearchFormInvolvedUnitsSection({
    form,
    options,
}: {
    form: UseFormReturn<EventSearchFormType>;
    options: EventSearchOptions;
}) {
    return (
        <FormSection width="100%" title="Involved Units">
            <Flex flex={1} flexFlow="wrap" gap="1rem" maxWidth="container.md">
                <Flex flexFlow="wrap" gap="1rem">
                    <Box w={INPUT_WIDTH_SM}>
                        <FormSelect
                            name="primaryUnits"
                            label="Primary Units"
                            control={form.control}
                            options={options.callSignOptions}
                            isMultiple={true}
                            truncateSelectedCount={2}
                        />
                    </Box>
                    <Box w={INPUT_WIDTH_SM}>
                        <FormSelect
                            name="involvedUnits"
                            label="Involved Units"
                            control={form.control}
                            options={options.callSignOptions}
                            isMultiple={true}
                            truncateSelectedCount={2}
                        />
                    </Box>
                </Flex>
                <Flex flexFlow="wrap" gap="1rem">
                    <Box w={INPUT_WIDTH_SM}>
                        <FormUserMultiSelect
                            name="primaryOfficers"
                            label="Primary Officers"
                            control={form.control}
                            truncateSelectedCount={2}
                        />
                    </Box>
                    <Box w={INPUT_WIDTH_SM}>
                        <FormUserMultiSelect
                            name="involvedOfficers"
                            label="Involved Officers"
                            control={form.control}
                            truncateSelectedCount={2}
                        />
                    </Box>
                </Flex>
            </Flex>
        </FormSection>
    );
}
